import React from 'react';
import StripeIcon from 'components/PaymentData/PaymentMethodSelector/components/StripeIcon';
import { isEmpty } from 'utils/types';

const NUMBER_OF_DAYS_FIELD = {
  fieldName: 'number_of_days',
  asideRightText: 'days',
  defaultValue: 30,
};
const PAYMENT_DAY_FIELD = {
  fieldName: 'payment_day',
  asideRightText: 'days',
  defaultValue: 30,
};

const validateNumberOfDaysAndPaymentDay = ({
  paymentTerms,
  numberOfDaysLimit,
  paymentDayLimit,
}) => {
  let errors = {};
  if (
    paymentTerms.number_of_days <= 0 ||
    paymentTerms.number_of_days > numberOfDaysLimit
  ) {
    errors = { ...errors, number_of_days: 'limit' };
  }
  if (
    paymentTerms.payment_day < 0 ||
    paymentTerms.payment_day > paymentDayLimit
  ) {
    errors = { ...errors, payment_day: 'limit' };
  }
  return errors;
};

const PAYMENT_METHOD = ({ country }) => ({
  confirming: {
    fields: [[NUMBER_OF_DAYS_FIELD, PAYMENT_DAY_FIELD]],
    limit: country === 'ES' ? 60 : 30,
    validations: (paymentTerms) =>
      validateNumberOfDaysAndPaymentDay({
        paymentTerms,
        numberOfDaysLimit: country === 'ES' ? 60 : 30,
        paymentDayLimit: 30,
      }),
  },
  direct_debit: {
    fields: [
      [{ fieldName: 'IBAN', isFullWidth: true, asideRightText: 'days' }],
      [
        country === 'FR'
          ? { ...NUMBER_OF_DAYS_FIELD, defaultValue: 40 }
          : NUMBER_OF_DAYS_FIELD,
        PAYMENT_DAY_FIELD,
      ],
    ],
    limit: country === 'ES' ? 60 : 30,
    validations: (paymentTerms) => {
      let errors = {};

      if (isEmpty(paymentTerms.IBAN)) {
        errors = { ...errors, IBAN: 'empty' };
      }
      if (!paymentTerms.SEPA) {
        errors = { ...errors, SEPA: 'should be true' };
      }

      errors = {
        ...errors,
        ...validateNumberOfDaysAndPaymentDay({
          paymentTerms,
          numberOfDaysLimit: country === 'ES' ? 60 : 30,
          paymentDayLimit: 30,
        }),
      };
      return errors;
    },
  },
  card: {
    fields: [],
    icon: () => <StripeIcon />,
    isCard: true,
  },
  pagare: {
    fields: [[NUMBER_OF_DAYS_FIELD, PAYMENT_DAY_FIELD]],
    limit: country === 'ES' ? 60 : 30,
    validations: (paymentTerms) =>
      validateNumberOfDaysAndPaymentDay({
        paymentTerms,
        numberOfDaysLimit: country === 'ES' ? 60 : 30,
        paymentDayLimit: 30,
      }),
  },
  transfer: {
    fields: [[NUMBER_OF_DAYS_FIELD, PAYMENT_DAY_FIELD]],
    limit: 30,
    validations: (paymentTerms) =>
      validateNumberOfDaysAndPaymentDay({
        paymentTerms,
        numberOfDaysLimit: 30,
        paymentDayLimit: 30,
      }),
  },
});

const PAYMENT_METHODS = {
  CONFIRMING: 'CONFIRMING',
  CARD: 'CARD',
  TRANSFER: 'TRANSFER',
  DIRECT_DEBIT: 'DIRECT_DEBIT',
  IOU: 'IOU',
};

const ACTIVE_PAYMENT_METHODS = [
  PAYMENT_METHODS.CONFIRMING,
  PAYMENT_METHODS.CARD,
  PAYMENT_METHODS.TRANSFER,
  PAYMENT_METHODS.DIRECT_DEBIT,
  PAYMENT_METHODS.IOU,
];

export default {
  NUMBER_OF_DAYS_FIELD,
  PAYMENT_DAY_FIELD,
  PAYMENT_METHOD,
  ACTIVE_PAYMENT_METHODS,
  PAYMENT_METHODS,
  validateNumberOfDaysAndPaymentDay,
};
